import { type ClipTranscriptCache, type TimeRange } from '~/swr-hooks/clips/transcript/types';

const hasStrictOverlap = (chunk: TimeRange, range: TimeRange) =>
  chunk.startTimeMs < range.endTimeMs && range.startTimeMs < chunk.endTimeMs;

export const stripRangeFromCachedTranscriptData = ({
  data,
  rangeToStrip,
}: {
  data: ClipTranscriptCache['data'];
  rangeToStrip: TimeRange;
}): ClipTranscriptCache['data'] => {
  return data.flatMap((chunk) => {
    if (!hasStrictOverlap(chunk, rangeToStrip)) {
      return [chunk];
    }

    const leftData = chunk.data.filter((segment) => segment.endTimeMs <= rangeToStrip.startTimeMs);
    const rightData = chunk.data.filter((segment) => segment.startTimeMs >= rangeToStrip.endTimeMs);

    const leftChunk =
      chunk.startTimeMs < rangeToStrip.startTimeMs
        ? {
            ...chunk,
            endTimeMs: rangeToStrip.startTimeMs,
            data: leftData,
          }
        : null;

    const rightChunk =
      rangeToStrip.endTimeMs < chunk.endTimeMs
        ? {
            ...chunk,
            startTimeMs: rangeToStrip.endTimeMs,
            data: rightData,
          }
        : null;

    return [leftChunk, rightChunk].filter((value) => value !== null);
  });
};
